<app-content-shell [contentId]="'questions-view'">
  <app-content-display-card [contentID]="'questions-view'">
    <!-- HEADER -->
    <ng-template #header>
      <div class="d-flex align-items-center justify-content-between w-100 pr-3">
        <div class="d-flex justify-content-end">
          <app-custom-paginator [totalLength]="totalLength()" [currentPage]="pageIndex()" [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)"></app-custom-paginator>
        </div>

        <div class="d-flex align-items-center gap-2 me-2">
          <button mat-icon-button class="button header-icon-button" color="primary" (click)="openSearch()" [matTooltip]="'Global.Search' | translate">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button class="button header-icon-button" color="primary" (click)="openAnalysisSidebar()" [matTooltip]="'Questions.TabAnalysis' | translate">
            <mat-icon>auto_awesome</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- BODY -->
    <ng-template #body>
      <div class="skz-container">
        <div class="collection-wrapper fade-in">
          <!-- Filter Bar -->
          <form [formGroup]="searchForm" class="d-flex align-items-center gap-2">
            <div class="flex-grow-1">
              <mat-label class="form-label mb-1">{{ 'Global.FilterList' | translate }}</mat-label>
              <mat-form-field appearance="fill" class="search-group w-100">
                <input matInput formControlName="searchTerm" [placeholder]="'Global.FilterPlaceholder' | translate" />
              </mat-form-field>
            </div>
            <div>
              <mat-label class="form-label mb-1">{{ 'Search.SearchType' | translate }}</mat-label>
              <mat-form-field appearance="fill">
                <mat-select formControlName="searchType" (selectionChange)="getQuestions($event)">
                  @for (searchType of searchTypes; track searchType) {
                    <mat-option [value]="searchType.value">{{ searchType.label | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </form>

          <!-- Questions Accordion -->
          <div class="accordion-container">
            <mat-accordion displayMode="default" multi="false">
              @for (question of filteredQuestions(); track question._id) {
                <mat-expansion-panel class="skz-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panel-title-content">
                        <span class="query-text">{{ question.query }}</span>
                      </div>
                    </mat-panel-title>
                    @if (userIsNotReader()) {
                      <mat-panel-description>
                        <button mat-icon-button (click)="deleteAIResponse(question._id, $event)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </mat-panel-description>
                    }
                  </mat-expansion-panel-header>

                  <div class="panel-body">
                    <div class="response-preview">
                      <markdown [data]="getAnswer(question)"></markdown>
                    </div>
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </div>
      </div>
    </ng-template>
  </app-content-display-card>
</app-content-shell>
